<template>
  <div>

    <div class="spot" ref="spot" :style="{top: top, left:left}">
      <div class="hotspot" @mouseover="mouseover" @mouseout="mouseout" @click="click"></div>
      <img :src="imgSrc" :srcset="imgSrcSet" :style="{'z-index':zindex}"/>
      <transition name="fade">
        <div  class="city-info" v-if="showInfo" :style="{right:posRight, left:posLeft, textAlign:cityInfoTextAlign}">
          <div class="city-name">{{city.name.toUpperCase()}}</div>
          <div class="city-date">{{city.address1}}</div>
          <div class="city-date" style="font-weight:400;">{{city.dateString}}</div>

        </div>
      </transition>
    </div>


  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "map-city-spot",
    props: ["city", "top", "left"],
    data() {
      return {
        showInfo: false,
        imgSrc: "/static/images/city-spot-copy.png",
        imgSrcSet: "/static/images/city-spot-copy@2x.png",
        zindex: 0,
        zindex2: 100,
        topHotSpot: '0px',
        posLeft: '95%',
        posRight: 'auto',
        cityInfoTextAlign:'left'
      }
    },
    mounted() {
      const parentBounds = this.$parent.$el.getBoundingClientRect();
      const myBounds = this.$refs.spot.getBoundingClientRect();

      if (myBounds.left + myBounds.width * 0.5 > parentBounds.left + parentBounds.width * 0.5) {
        this.posLeft = 'auto';
        this.posRight = '95%';
        this.cityInfoTextAlign = 'right';
      } else {
        this.posLeft = '95%';
        this.posRight = 'auto';
        this.cityInfoTextAlign = 'left';
      }

      this.imgSrc = '/static/images/city-spot-copy.png';
      this.imgSrcSet = '/static/images/city-spot-copy@2x.png';

    },
    computed: {
      cityDate: function () {
        let date = moment(this.city.startDate).format('DD.MM.') + ' - ' + moment(this.city.endDate).format('DD.MM.YYYY');
        return date;
      }
    },
    methods: {
      mouseover() {

        this.imgSrc = '/static/images/city-spot-overlay.png';
        this.imgSrcSet = '/static/images/city-spot-overlay@2x.png';
        this.showInfo = true;
        this.zindex = 10;
      },
      mouseout() {
        this.imgSrc = '/static/images/city-spot-copy.png';
        this.imgSrcSet = '/static/images/city-spot-copy@2x.png';
        this.showInfo = false;
        this.zindex = 0;
      },
      click() {

        this.showInfo = false;
        this.$router.push(`/${this.city.key}`);
        // this.$router.push('/test');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .spot {
    position: absolute;
    width: 10vw;
    max-width: 120px;
    /*background-color: aqua;*/

  }

  .spot img {
    width: 100%;
    pointer-events: none !important;
    position: relative;

  }

  .hotspot {
    width: 3vw;
    height: 3vw;
    /*background-color: yellow;*/
    position: absolute;
    left: calc(50% - 1.5vw);
    top: calc(50% - 1.5vw);

    cursor: pointer;
    z-index: 50;
  }

  $min-width: 800px;
  $max-width: 1200px;

  .city-info {
    position: absolute;
    top: 10%;
    z-index: 3;
    /*right: 95%;*/
    padding: 1rem;
    background-color: rgba(52, 126, 152, 0.5);
    //text-align: center;
    /*min-width: 300px;*/
    pointer-events: none;
    white-space: nowrap;
  }

  .city-name {
    font-size: 2.2vw;
    font-weight: 400;
    line-height: 2vw;
    @media screen and (max-width: $min-width) {
      font-size: 18px;
    }

    @media screen and (min-width: $max-width) {
      font-size: 24px;
    }

  }

  .city-date {
    font-size: 1.5vw;
    font-weight: 200;

    @media screen and (max-width: $min-width) {
      font-size: 13px;
    }

    @media screen and (min-width: $max-width) {
      font-size: 16px;
    }
  }

  fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/MapCitySpot.vue